module.exports = __webpack_public_path__ + "media/images/purple_coral-510f0e66eb4d7b6f6ebb882e8ea65d62.jpg";